import { Injectable } from '@angular/core'
import { Store } from '@ngrx/store'
import { Observable } from 'rxjs/Observable'
import 'rxjs/add/operator/do'

import { PaginatedList } from '../libs/infinite-paginator'
import { Lecture } from '../models'
import { LectureApi } from '../apis'
import { AppState } from '../reducers'
import { SetLectures, SelectLecture, AddLecture } from '../actions/lecture'

@Injectable()
export class LectureService {
  lectureList: PaginatedList<Lecture>

  constructor(
    private api: LectureApi,
    private store: Store<AppState>,
  ) {
  }

  loadLectures(): Observable<Lecture[]> {
    this.lectureList = this.api.index()

    return this.lectureList.items
                           .do((list: Lecture[]) => this.store.dispatch(new SetLectures(list)))
  }

  loadChildLectures(id: number): Observable<Lecture[]> {
    this.lectureList = this.api.children(id)

    return this.lectureList.items
                           .do((list: Lecture[]) => this.store.dispatch(new SetLectures(list)))
  }

  selectLecture(lectureId: number): Observable<Lecture> {
    return this.api.get(lectureId)
                   .do((l: Lecture) => this.store.dispatch(new SelectLecture(l)))
  }

  update(lectureId: number, params: any): Observable<Lecture> {
    return this.api.update(lectureId, params)
                   .do(l => this.store.dispatch(new SelectLecture(l)))
  }

  create(params: any): Observable<Lecture> {
    return this.api.create(params)
      .do(l => this.store.dispatch(new AddLecture(l)))
  }

  create_child(id:number, params: any): Observable<Lecture> {
    return this.api.create_child(id, params)
      .do(l => this.store.dispatch(new AddLecture(l)))
  }
}



// WEBPACK FOOTER //
// ./src/services/lecture.ts